//@ts-check

module.exports = (fox) => {

	var _ = {
		getTranslation: function(alias) {
			var translation = {
				'proceed': fox.i18n.getTranslation('proceed', 'Proceed', 'dialog'),
				'cancel': fox.i18n.getTranslation('cancel', 'Cancel', 'dialog'),
				'secretTitle': fox.i18n.getTranslation('secretTitle', 'Enter secret password', 'dialog'),
				};
			return translation[alias] || '';
		}
	};

	fox.registerWidget('Popup_Form', {
		configure: function () {
			this.registerOptions('', {
				onCancelPress: (...args) => this.onCancel(...args),
				additionalClass: 'custom-popup-title',
				dialog:{
					width: '390px',
				},

				widgets: {
					form: {
						widget: 'DomForm'
					},
					content:{
						handleDom:{
							focus: {
								target: 'input',
								event: 'focus',
								callback: (elt) => this.removeError(elt.name)
							}
						}
					}
				}
			});
			this.callParent('configure', arguments);
		},

		onCancel() {
			this.enableButton()
			//this.removeError();
			this.hide();
			return fox.Promise.resolve(false);
		},

		enableButton() {
			let elt = this.dom1('#on-success');
			elt.classList.remove('spin');
			elt.setAttribute('disable', false);
		},

		disableButton() {
			let elt = this.dom1('#on-success');
			elt.classList.add('spin');
			elt.setAttribute('disable', true);
		},

		showError(msg) {
			this.enableButton();
			if(!msg.message) return;
			let containers = this.getContainers(msg.field);
			containers.errorContainer.innerText = msg.message;
			containers.parent.classList.add('error');
		},

		removeError(field) {
			let containers = this.getContainers(field);
			containers.errorContainer.innerText = '';
			containers.parent.classList.remove('error');
		},

		getContainers(field) {
			let fieldElt = this.wom1('#form').getElement(field).getNodes()[0];
			let parent = fieldElt.parentNode;
			let errorContainer = fox.dom.selectFirst('.message ', parent);

			return {
				field: fieldElt,
				parent: parent,
				errorContainer: errorContainer
			}
		}

	}, 'GDPR_BasePopup');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/security-payment-details/widget/formPopup.es.js